// extracted by mini-css-extract-plugin
export default {"dimBackground":"ContactForm_dimBackground__ysIOS","formWrapper":"ContactForm_formWrapper__Zq461","logoWrapper":"ContactForm_logoWrapper__hNmPl","form":"ContactForm_form__M8bRI"};